(() => {
  const config = document.currentScript?.dataset || {};
  const loaded = new Set();

  function loadScript(key, src) {
    if (loaded.has(key) || document.querySelector(`script[data-bf-app="${key}"]`)) return;
    loaded.add(key);
    const script = document.createElement('script');
    script.src = src;
    script.async = true;
    script.dataset.bfApp = key;
    document.head.appendChild(script);
  }

  function loadDeferredApps() {
    if (config.klaviyo === 'true') {
      loadScript('klaviyo', 'https://static.klaviyo.com/onsite/js/U3qaps/klaviyo.js?company_id=U3qaps');
    }
    if (config.fbt === 'true') {
      loadScript('frequently-bought-together', 'https://cdn.codeblackbelt.com/widgets/frequently-bought-together/bootstrap.min.js');
    }
  }

  const interactionEvents = ['pointerdown', 'touchstart', 'keydown', 'scroll'];
  interactionEvents.forEach((eventName) => {
    window.addEventListener(eventName, loadDeferredApps, { once: true, passive: true });
  });

  const schedule = () => window.setTimeout(loadDeferredApps, config.fbt === 'true' ? 1800 : 2800);
  if (document.readyState === 'complete') schedule();
  else window.addEventListener('load', schedule, { once: true });
})();
